import addIcon from '@iconify/icons-carbon/add';
import subtractIcon from '@iconify/icons-carbon/subtract';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Image from 'next/image';
import { Trans, useTranslation } from 'next-i18next';
import { useState } from 'react';

import { Iconify } from '@larvitu/shared/mui/ui-iconify';
import { Link } from '@larvitu/shared/next/mui';

import doctor1 from '../../public/assets/images/geiges/859_Dr_Geiges_007.jpg';
import doctor2 from '../../public/assets/images/geiges/859_Dr_Geiges_011.jpg';

import type { ImageProps } from 'next/legacy/image';
import type { FC, SyntheticEvent } from 'react';

const DEFAULT_FAQS: FAQ[] = [
  {
    id: '1',
    question:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam feugiat tincidunt est et pulvinar.',
    answer:
      'uspendisse potenti. Nunc tellus eros, sollicitudin ac tortor nec, rhoncus ultrices dolor. Fusce tortor lorem, consectetur quis rutrum ac, tristique nec erat. Sed facilisis enim in justo congue ullamcorper. Integer nec tempor elit. Suspendisse malesuada dignissim elementum. Nullam porttitor convallis leo in sollicitudin. Aenean vitae lacus metus.',
  },
  {
    id: '2',
    question:
      'Curabitur auctor turpis blandit commodo sollicitudin. Nulla sollicitudin, augue ut posuere mollis',
    answer:
      'Maecenas imperdiet dui neque, ut interdum eros pellentesque ac. Sed quis convallis lacus. Duis mattis gravida libero quis efficitur. Vestibulum ligula purus, gravida at mattis finibus, sodales id dui. Praesent vitae placerat mi. Pellentesque cursus convallis libero, ac tristique nibh tincidunt ornare. Phasellus maximus sodales tortor non vulputate',
  },
];

export interface FaqsProps {
  items?: FAQ[];

  image?: ImageProps['src'];
}

export interface FAQ {
  id: string;

  question: string;

  answer: string;
}

// ----------------------------------------------------------------------

const RootStyle = styled( 'div' )(({ theme }) => ({
  padding: theme.spacing( 8, 0 ),
  [theme.breakpoints.up( 'md' )]: {
    padding: theme.spacing( 10, 0, 15, 0 ),
  },
}));

// ----------------------------------------------------------------------

export const FAQS: FC<FaqsProps> = ({ items = DEFAULT_FAQS }) => {
  const [expanded, setExpanded] = useState<string | false>( false );
  const handleChangeExpanded = (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded( isExpanded ? panel : false );
  };
  const { t } = useTranslation( ['faq', 'common'] );

  return (
    <RootStyle>
      <Container>
        <Grid container spacing={3} justifyContent="space-between">
          <Grid
            item
            order={{ xs: 2, md: 1 }}
            xs={12}
            md={6}
            lg={6}
            display="flex"
            flexDirection="column"
          >
            <Stack spacing={2} sx={{ mb: 5 }}>
              <Typography variant="h2">
                {/* @ts-ignore */}
                {t( 'faq', { ns: 'common' } )}
              </Typography>
            </Stack>

            {items.map((faq) => (
              <Accordion
                key={faq.id}
                expanded={expanded === faq.question}
                onChange={handleChangeExpanded( faq.question )}
              >
                <AccordionSummary>
                  <Box
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="h5"
                      maxWidth="90%"
                      sx={{ flexGrow: 1 }}
                    >
                      {faq.question}
                    </Typography>
                    <Iconify
                      icon={expanded === faq.question ? subtractIcon : addIcon}
                      sx={{
                        width: 24,
                        height: 24,
                        alignSelf: 'center',
                      }}
                    />
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <Trans
                      t={t}
                      shouldUnescape
                      components={{
                        a: <a />,
                        Link: <Link href=""/>,
                      }}
                    >
                      {faq.answer}
                    </Trans>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>

          <Grid
            item
            order={{ xs: 1, md: 2 }}
            xs={12}
            md={6}
            lg={5}
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Box width="100%">
              <Image
                sizes="(max-width: 900px) 95vw,(max-width: 1200px) 50vw, (max-width: 1536px) 60vw, 25vw"
                src={doctor1}
                alt="Dr Geiges"
                title="Dr Herold"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
                placeholder="blur"
              />
            </Box>
            <Box width="100%">
              <Image
                sizes="(max-width: 900px) 95vw,(max-width: 1200px) 50vw, (max-width: 1536px) 60vw, 25vw"
                src={doctor2}
                alt="Dr Geiges"
                title="Dr Herold"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
                placeholder="blur"
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
};
